import nolimit from './nolimit.js';

const providers = {
	nolimitcity: nolimit
};

function load(providerAndParametersString) {
	const providerAndParameters = JSON.parse(providerAndParametersString);
	providers[providerAndParameters.provider].load(providerAndParameters.parameters);
}

export default { load };



// WEBPACK FOOTER //
// ./mobile-core/src/casino/providers/provider-loader.js